import { Helmet } from "react-helmet";

interface BlankTemplateProps {
  children: React.ReactNode;
  pageTitle?: string;
  contactFooter?: boolean;
}

const BlankTemplate = ({
  children,
  pageTitle = "Vojomo Admin",
  contactFooter = true
}: BlankTemplateProps): React.ReactNode => {
  return (
    <div className="App">
      <Helmet>
        <title>{`Vojomo Admin${
          pageTitle !== "Vojomo Admin" ? " | " + pageTitle : ""
        }`}</title>
      </Helmet>

      <header className="App-header"></header>

      <div className="mx-10">
        <img
          src={require("@vojomo-core/shared/src/static/Vojomo_Horiz_fullcolor_rgb.png")}
          alt="Vojomo"
          className="w-62.5 mt-6.25"
        />
        {children}

        {contactFooter && (
          <footer className="text-sm italic fixed bottom-0 mb-6.25">
            <br />
            <p>
              Please contact{" "}
              <a href="mailto:matthew.balick@vojomo.com">
                matthew.balick@vojomo.com
              </a>{" "}
              for any questions.
            </p>
          </footer>
        )}
      </div>
    </div>
  );
};

export default BlankTemplate;
